angular
  .module("admin.subscriptions")
  .controller(
    "SubscriptionDetails",
    function (
      $stateParams,
      $filter,
      $http,
      $uibModal,
      $state,
      config,
      SubscriptionDetailsResource,
      FreePlayResource,
      ChangeCustomerCredentialsResource,
      CnpjUtils
    ) {
      let { subscriptionNumber } = $stateParams;
      this.userSearch = "";
      this.details = null; // Initialize as null, will be set from API
      this.statusFilter = "ACTIVATED"; // ALL, NEW, ACTIVATED, SUSPENDED - padrão: Ativos
      this.config = config;

      this.subscribersPagination = {
        page: 1,
        pageSize: 24,
      };
      this.paginatedSubscribers = [];
      this.allSubscribers = []; // Para contar os status

      this.closeAlert = function (i) {
        this.alerts.splice(i, 1);
      };

      this.formatPhone = function (phone) {
        return Number(`${phone.areaCode}${phone.number}`);
      };

      this.loadDetails = function () {
        SubscriptionDetailsResource.get(
          {
            subscriptionNumber,
          },
          (response) => {
            this.details = response.data;
            // TODO: Consider moving the transformation to the back.
            if (this.details.administrator && this.details.administrator.phone) {
              this.details.administrator.phone = this.formatPhone(
                this.details.administrator.phone
              );
            }

            if (this.details.administrator && this.details.administrator.mobile) {
              this.details.administrator.mobile = this.formatPhone(
                this.details.administrator.mobile
              );
            }

            if (this.details.organization && this.details.organization.phone1) {
              this.details.organization.phone1 = this.formatPhone(
                this.details.organization.phone1
              );
            }

            if (this.details.organization && this.details.organization.phone2) {
              this.details.organization.phone2 = this.formatPhone(
                this.details.organization.phone2
              );
            }

            this.details.invoiceRecipients = this.details.invoiceRecipients.map(
              (recipient) => {
                return {
                  id: recipient.id,
                  name: recipient.name,
                  email: recipient.email,
                  phone: this.formatPhone(recipient.phone),
                };
              }
            );

            if (this.details.organization && this.details.organization.cnpj) {
              this.details.organization.cnpj = CnpjUtils.normalize(
                this.details.organization.cnpj
              );
            }

            this.checkExclusion();
            this.loadFreeplay();
            this.loadSubscribers();
            // this.getTrials();
          },
          (err) => {
            this.subscriptionNotFound = true;
          }
        );
      };

      this.loadDetails();

      this.getTrials = function () {
        SubscriptionDetailsResource.getTrials(
          {
            subscriptionNumber: this.details.number,
          },
          (data) => {
            this.trial = data[0];
          }
        );
      };
      this.isTrial = function () {
        if (this.trial && !this.trial.upgradeDate) {
          var d = new Date(this.trial.endDate);
          return d > new Date();
        } else {
          return false;
        }
      };


      this.loadSubscribers = function () {
        // Reseta a página quando pesquisa
        this.subscribersPagination.page = 1;

        // Prepara os parâmetros
        var params = {
          subscriptionNumber: subscriptionNumber,
          page: 1,
          limit: 1000, // Carrega muitos para ter todos os dados
          allSubscribers: true, // Sempre exibe todos os usuários
        };

        // Adiciona search apenas se houver valor
        if (this.userSearch && this.userSearch.trim()) {
          params.search = this.userSearch.trim();
        }

        // Carrega todos os usuários para contar os status
        SubscriptionDetailsResource.getSubscribers(
          params,
          (response) => {
            this.allSubscribers = response.data.data || [];
            this.subscribersPagination.total = response.data.metadata ? response.data.metadata.total : 0;
            this.applyStatusFilter();
          },
          (error) => {
            console.error("[SubscriptionDetails] Erro ao carregar usuários:", error);
            this.allSubscribers = [];
            this.subscribersPagination.total = 0;
            this.applyStatusFilter();
          }
        );
      };

      this.applyStatusFilter = function () {
        var filtered = [];
        if (this.statusFilter === "ALL") {
          filtered = this.allSubscribers;
        } else {
          filtered = this.allSubscribers.filter((user) => {
            return user.status && user.status.toUpperCase() === this.statusFilter;
          });
        }

        // Aplica paginação local
        var start = (this.subscribersPagination.page - 1) * this.subscribersPagination.pageSize;
        var end = start + this.subscribersPagination.pageSize;
        this.paginatedSubscribers = filtered.slice(start, end);
      };

      this.setStatusFilter = function (status) {
        this.statusFilter = status;
        this.subscribersPagination.page = 1;
        this.applyStatusFilter();
      };

      this.changePage = function () {
        this.applyStatusFilter();
      };

      this.getStatusCount = function (status) {
        // Os contadores já refletem os resultados da pesquisa porque allSubscribers
        // já contém apenas os resultados filtrados pela pesquisa do servidor
        if (!this.allSubscribers || this.allSubscribers.length === 0) return 0;
        if (status === "ALL") return this.allSubscribers.length;
        return this.allSubscribers.filter((user) => {
          return user.status && user.status.toUpperCase() === status;
        }).length;
      };

      this.selectSubscriber = function (u) {
        $uibModal
          .open({
            controller: "EditCustomerModalCtrl",
            templateUrl: "views/customers/edit-customers.html",
            controllerAs: "ctrl",
            backdrop: "static",
            resolve: {
              customer: () => u,
            },
          })
          .result.then(
            () => {
              this.alerts = [
                { type: "success", message: "Os dados foram salvos!" },
              ];
              // Refresh subscribers list after successful update
              if (this.details && this.details.organization) {
                this.loadSubscribers();
              }
            },
            () => {}
          );
      };

      this.changeAdmin = function (user) {
        $uibModal
          .open({
            component: "changeAdminModal",
            resolve: {
              customer: () => user,
              subscriptionNumber: () => subscriptionNumber,
            },
          })
          .result.then(() => this.loadDetails());
      };

      this.deleteCustomer = function (u) {
        $uibModal
          .open({
            template: `
                <div class="modal-header">
                    <h3>Excluir {{ctrl.customer.firstName}} {{ctrl.customer.lastName}}</h3>
                </div>
                <div class="modal-body">
               <p>
                    Tem certeza que deseja excluir <strong>{{ctrl.customer.firstName}} {{ctrl.customer.lastName}}</strong>?
                    </p>
                </div>
                <div class="modal-footer">
                    <button ng-disabled="ctrl.working" type="button" ng-click="ctrl.cancel()" class="btn btn-link">Cancelar</button>
                    <button  ng-disabled="ctrl.working" type="button" ng-click="ctrl.confirmDelete()" class="btn btn-danger">Sim, excluir {{ctrl.customer.firstName}}</button>
                </div>
                `,
            controllerAs: "ctrl",
            controller: function (
              AdminCustomersResource,
              $uibModalInstance,
              customer
            ) {
              this.customer = customer;

              this.confirmDelete = function () {
                this.working = true;
                let request = { id: this.customer.id };
                AdminCustomersResource.deleteCustomer(
                  request,
                  (res) => {
                    this.working = false;
                    $uibModalInstance.close();
                  },
                  (err) => {
                    console.error(err);
                    this.working = false;
                  }
                );
              };
              this.cancel = function () {
                $uibModalInstance.dismiss();
              };
            },
            resolve: {
              customer: () => u,
            },
          })
          .result.then(() => {
            this.loadSubscribers();
          });
      };

      this.checkExclusion = function () {
        this.canDelete = false;
        $http({
          method: "GET",
          url:
            config.api +
            "/api/v1/subscriptions/" +
            subscriptionNumber +
            "/can-delete",
        }).then(
          (response) => {
            this.canDelete = response.data.data.canDelete;
          },
          (err) => {}
        );
      };

      this.deleteSubscription = function () {
        if (!this.canDelete) return;

        $uibModal
          .open({
            template: `
                <div class="modal-header">
                    <h3>Excluir Assinatura</h3>
                </div>
                <div class="modal-body">
                Tem certeza que deseja excluir esta assinatura?
                </div>
                <div class="modal-footer">
                    <button ng-click="$ctrl.cancel()" class="btn btn-link">Não</button>
                    <button ng-click="$ctrl.confirm()" class="btn btn-danger">SIM, EXCLUIR</button>
                </div>

                `,
            controllerAs: "$ctrl",
            controller: function ($uibModalInstance) {
              this.cancel = function () {
                $uibModalInstance.dismiss();
              };
              this.confirm = function () {
                $uibModalInstance.close();
              };
            },
          })
          .result.then(
            () => {
              $http({
                method: "DELETE",
                url:
                  config.api +
                  "/api/v1/subscriptions/" +
                  subscriptionNumber,
              }).then(
                () => {
                  $state.go("admin.subscriptions");
                },
                (err) => {}
              );
            },
            () => {}
          );
      };

      this.exportSubscribers = function () {
        $http({
          url:
            config.api +
            `/api/v1/subscriptions/${subscriptionNumber}/subscribers/export-to-csv`,
          method: "GET",
          responseType: "arraybuffer",
        }).then((res) => {
          var filename = `ListaUsuarios_${subscriptionNumber}.csv`;

          res.headers();
          var url = URL.createObjectURL(
            new Blob([res.data], { type: "arraybuffer" })
          );
          var a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.target = "_blank";
          a.click();
        });
      };

      this.loadFreeplay = function () {
        FreePlayResource.get(
          {
            subscriptionNumber,
          },
          (response) => {
            const freeplay = response.data;

            if (!freeplay.id) {
              this.freeplay = null;
              this.freeplayStatus = null;
              return;
            }

            this.freeplay = freeplay;

            const endDate = new Date(freeplay.endDate);
            const startDate = new Date(freeplay.startDate);
            const now = new Date();

            if (startDate > now) {
              this.freeplayStatus = "future";
            }

            if (!freeplay.endDate || endDate > now) {
              this.freeplayStatus = "valid";
            }

            if (freeplay.endDate && endDate < now) {
              this.freeplayStatus = "expired";
            }

          }
        );
      };
    }
  )
  .config(function ($stateProvider) {
    $stateProvider.state("admin.subscriptionDetails", {
      controller: "SubscriptionDetails",
      controllerAs: "ctrl",
      templateUrl: "views/subscriptions/details.html",
      url: "subscription/{subscriptionNumber}",
      data: {
        permissions: {
          only: "admin.subscriptions",
          redirectTo: "admin",
        },
      },
    });
  });
